import noticeError from "src/app/utilities/noticeError";
import { getSierraConfig } from "src/app/components/SierraChat/utils/getSierraConfig";

import getQueryParamValue from "src/utilities/getQueryParamValue";
import { getSierraInstance } from "src/app/components/SierraChat/utils/getSierraInstance";

export const setChatWidgetParam = () => {
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href);
    url.searchParams.set("showChatWidget", "true");
    window.history.replaceState({}, "", url.toString());
  }
};

export const deleteChatWidgetParam = () => {
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href);
    url.searchParams.delete("showChatWidget");
    window.history.replaceState({}, "", url.toString());
  }
};

export const sierraChatTimeoutAction = (timeout, setShow, setLoadError) => {
  timeout = setTimeout(() => {
    const sierraChatContainer = document.querySelector(
      "#sierra-chat-container"
    );

    const sierraChatWidget =
      sierraChatContainer?.shadowRoot?.querySelector("main");

    if (!sierraChatWidget && getQueryParamValue("showChatWidget")) {
      deleteChatWidgetParam();
      const timeoutError = new Error("Sierra Chat: Timeout error");
      noticeError(timeoutError);
      setShow(false);
      setLoadError(timeoutError);
    }
  }, 5000);
};

export const init = async (toggleChatModal) => {
  const sierraInstance = getSierraInstance();

  window.sierraConfig = await getSierraConfig();

  const agentScript = document.createElement("script");
  agentScript.type = "module";
  agentScript.onload = toggleChatModal;
  agentScript.src = sierraInstance;
  document.head.appendChild(agentScript);

  return () => {
    document.head.removeChild(agentScript);
  };
};
